import { supabase } from "../supabase";

export async function getImage(imageId) {
    return (await supabase.from('image').select().eq('image_id', imageId).single()).data;
}

export async function getImages(imageIds) {
    return await supabase
        .from('image')
        .select()
        .in('image_id', imageIds);
}

export async function getImageUrl(storage_path) {
    const { data } = supabase.storage.from('images').getPublicUrl(storage_path);
    return data.publicUrl;
}

export async function getImageUrlFromId(imageId) {
    let image = (await supabase.from('image').select().eq('image_id', imageId).single()).data;
    console.log('getting image', image)
    const { data } = supabase.storage.from('images').getPublicUrl(image.storage_path);
    return data.publicUrl;
}
